import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    id: 1,
    question: 'What services do you offer?',
    answer: 'I specialize in seven core areas: Graphics design, YouTube automation, AI-driven finance systems, AI applications, coding and development, automation workflows, and chatbot development. Each service is tailored to meet specific project needs.'
  },
  {
    id: 2,
    question: 'How do you ensure quality work?',
    answer: 'I follow industry best practices, use professional-grade tools, and maintain strong attention to detail throughout every project. Quality assurance and testing are integral parts of my workflow.'
  },
  {
    id: 3,
    question: 'What is your approach to projects?',
    answer: 'I focus on understanding the core problem first, then develop clear solutions with measurable outcomes. Communication is key throughout the process, ensuring alignment with project goals.'
  },
  {
    id: 4,
    question: 'Do you work on custom projects?',
    answer: 'Absolutely. Every project is unique, and I tailor my approach to match specific requirements, whether it\'s building from scratch or enhancing existing systems.'
  },
  {
    id: 5,
    question: 'What makes your work different?',
    answer: 'I combine technical expertise with creative problem-solving. The focus is on delivering functional, polished solutions that create real value rather than just checking boxes.'
  },
  {
    id: 6,
    question: 'How do you handle complex projects?',
    answer: 'Complex projects are broken down into clear phases with defined milestones. This approach ensures steady progress, quality at each step, and transparency throughout the development process.'
  }
];

const FAQSection = () => {
  const [openId, setOpenId] = useState(null);

  const toggleFAQ = (id) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        {/* Section Header */}
        <div className="mb-16 text-center">
          <p className="text-sm text-gray-800 mb-4 font-medium tracking-wide">/ Common Questions</p>
          <h2 className="text-5xl md:text-7xl font-bold text-black mb-6">
            Frequently Asked <span className="text-orange-500">Questions</span>
          </h2>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              <button
                onClick={() => toggleFAQ(faq.id)}
                className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gray-50 transition-colors duration-300"
              >
                <h3 className="text-lg md:text-xl font-bold text-black pr-4">{faq.question}</h3>
                <div className="flex-shrink-0">
                  {openId === faq.id ? (
                    <ChevronUp className="w-6 h-6 text-orange-500" />
                  ) : (
                    <ChevronDown className="w-6 h-6 text-gray-600" />
                  )}
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-8 pb-6">
                  <p className="text-gray-900 leading-relaxed font-medium">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;